module.exports = __webpack_public_path__ + "static/img/payway3.a473d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway3.png
// module id = 0yU0
// module chunks = 0